import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class Betgames extends Component {
	state = {
		token    : '',
		lang     : 'ru',
		timezone : '3',
		partner  : '',
		server   : ''
	};

	componentWillMount() {
		this.getData();
	}

	getData() {
		Xhr.getBetgamesData().then((resp) => {
			this.setState({...resp.data}, () => {
				const {token, partner, server, lang} = this.state;

				const BetGames = window['BetGames'];

				BetGames.frame(function (token) {
					const out = [];

					out.push(['token', token]);
					out.push(['language', lang]);
					out.push(['timezone', '3']);
					out.push(['partner', partner]);
					out.push(['server', server]);

					if ( window.location.href.indexOf('7x42') !== -1 ) {
						out.push(['current_game', '1']);
					}

					if ( window.location.href.indexOf('6x60') !== -1 ) {
						out.push(['current_game', '9']);
					}

					if ( window.location.href.indexOf('5x36') !== -1 ) {
						out.push(['current_game', '3']);
					}

					if ( window.location.href.indexOf('bones') !== -1 ) {
						out.push(['current_game', '4']);
					}

					if ( window.location.href.indexOf('duel-bones') !== -1 ) {
						out.push(['current_game', '10']);
					}

					if ( window.location.href.indexOf('poker') !== -1 ) {
						out.push(['current_game', '5']);
					}

					if ( window.location.href.indexOf('bakkara') !== -1 ) {
						out.push(['current_game', '6']);
					}

					if ( window.location.href.indexOf('fortune') !== -1 ) {
						out.push(['current_game', '7']);
					}

					if ( window.location.href.indexOf('ratesWar') !== -1 ) {
						out.push(['current_game', '8']);
					}

					return out;
				}(token, lang));
			});
		});
	}

	render() {
		return null;
	}
}

export default withRouter(
	connect(
		state => ({
			auth : state.auth
		}),
		dispatch => ({})
	)(Betgames)
);


// WEBPACK FOOTER //
// ./src/app/pages/Betgames/Betgames.js